import { useInvoicesInvoicesListQuery } from '@bambi/api-client/bambi';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';
import { useState } from 'react';

import { MultiSelect } from 'src/common/primitives/MultiSelect/MultiSelect';

interface InvoiceMultiSelectFilterProps {
  selected: SelectOption[];
  onChange: (selected: SelectOption[]) => void;
}

export function InvoiceMultiSelectFilter({
  selected,
  onChange,
}: InvoiceMultiSelectFilterProps) {
  const [query, setQuery] = useState('');

  const { data } = useInvoicesInvoicesListQuery(
    { search: query, pageSize: 50 },
    { skip: !query && selected.length === 0 }
  );

  const options: SelectOption[] =
    data?.results.map((invoice) => ({
      label: invoice.number,
      value: invoice.id,
    })) ?? [];

  return (
    <MultiSelect
      options={options}
      selected={selected}
      onChange={(value) => onChange(value as SelectOption[])}
      placeholder="Select invoices or leave blank to include all"
      searchable
      query={query}
      setQuery={setQuery}
    />
  );
}
